/*
 Push an object in the dataLayer for every promotion container on the homepage.
 Example format:

{
  'id': 'BELLES20 - BRIDESMAID',
  'name': 'Belles Are Ringing - Bridesmaid',
  'position': 'vp3-cr2-m1-btn1'
}
*/

const dataLayer = window.dataLayer || [];

export default () => {
  const promotions = [];
  const isDesktop = window.innerWidth > 767;
  const creative = isDesktop
    ? document.querySelectorAll('[data-promo-tracking], [data-promo-tracking-desktop]')
    : document.querySelectorAll('[data-promo-tracking], [data-promo-tracking-mobile]');

  let promoIndex = 0;
  const promotionTypeList = [];

  let vpNumber = 1;
  let ptNumber = 1;
  let mNumber = 1;

  creative.forEach((el, i) => {
    const trackingId = el.closest('[data-tracking-id]').getAttribute('data-tracking-id');
    const sectionId = el.closest('[data-section-id]').getAttribute('data-section-id');
    const prevSectionId = i > 0 ? creative[i - 1].closest('section, footer').getAttribute('data-section-id') : null;
    const creativeName = el.getAttribute('data-promo-creative')
      ? el.getAttribute('data-promo-creative')
      : el.closest('section, footer').getAttribute('data-section-type');
    const promotionCTA = el.textContent.trim();
    let promotionName = promotionCTA ? promotionCTA : creativeName;

    // container type (cr, sldr, hero, vdo, grid, cta)
    const containerTypeElement = el.closest('[data-container-type]');
    let ct = containerTypeElement ? containerTypeElement.getAttribute('data-container-type') : null;

    // promo type (btn, txt, link, img)
    const promoTypeElement = el.closest('[data-promo-type]');
    const pt = promoTypeElement ? promoTypeElement.getAttribute('data-promo-type') : null;

    let ctNumber = 1;

    promotionTypeList.push(pt);

    // Set containerType to carousel for mobile Pods
    if (el.closest('section, footer')?.getAttribute('data-section-type') === 'INF-Pods') {
      const heading = el.closest('section, footer').querySelector('.Pod__heading')?.textContent.trim();
      if (el.closest('section, footer').querySelector('.PodsCarousel') && !isDesktop) {
        el.closest('[data-container-type]').setAttribute('data-container-type', 'cr');
        ct = 'cr';

        if (prevSectionId === trackingId) {
          mNumber++;
        } else {
          mNumber = 1;
        }
      }

      // If Pod has headings (h1, h2, h3 etc), use heading as the promo name. Otherwise, use CTA text as promo name.
      if (heading) {
        promotionName = heading;
      } else if (promotionCTA) {
        promotionName = promotionCTA;
      } else {
        promotionName = creativeName;
      }
    }

    // count container type number
    const ctList = Array.from(creative).filter((item) => {
      const containerType = item.closest('[data-container-type]');
      return containerType && containerType.getAttribute('data-container-type') === ct;
    });

    const ctListIds = ctList
      .map((item) => {
        const sectionIdElement = item.closest('[data-section-id]');
        return sectionIdElement ? sectionIdElement.getAttribute('data-section-id') : null;
      })
      .filter((id) => id !== null);

    for (let index = 0; index < ctListIds.length; index++) {
      if (ctListIds[index] === sectionId) {
        break;
      } else if (ctListIds[index] !== ctListIds[index - 1]) {
        ctNumber++;
      }
    }

    // count promo type number
    if (promoIndex !== 0) {
      if (promotions[i - 1].creative === creativeName && promotionTypeList[i - 1] === pt) {
        ptNumber++;
      } else {
        ptNumber = 1;
      }

      // count view position number
      if (promotions[i - 1].creative !== creativeName) {
        vpNumber++;
      }
    }

    const concatPosition = `vp${vpNumber}-${ct + ctNumber}-m${mNumber}-${pt + ptNumber}`;

    const promo = {
      id: trackingId,
      creative: creativeName,
      name: promotionName,
      position: concatPosition,
    };

    el.dataset.sectionTracking = concatPosition;

    promotions.push(promo);
    promoIndex++;
  });
  // Remove promoView to prevent double sending on GTM.
  dataLayer.push({
    ecommerce: {
      promoView: {
        promotions: promotions,
      },
    },
  });
};
